import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Save, CheckCircle2 } from "lucide-react";

export default function SettingsAdmin() {
  const [form, setForm] = useState({ phone: "", email: "", city: "", hours: "", reviews_url: "", map_url: "", rating_value: "", rating_count: "", rating_source: "Google" });
  const [saved, setSaved] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => {
    api.get("/settings").then((r) => setForm((f) => ({ ...f, ...r.data })));
  }, []);

  const save = async () => {
    await api.put("/admin/settings", form);
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const inputCls = "w-full px-4 py-3 rounded-lg bg-[#0b0e13] border border-white/10 text-white focus:border-[#2f9fe6] outline-none transition-colors";
  const fields = [
    { k: "phone", label: "Phone" },
    { k: "email", label: "Email" },
    { k: "city", label: "City / Region" },
    { k: "hours", label: "Business hours" },
    { k: "reviews_url", label: "Google Reviews URL" },
    { k: "map_url", label: "Google Maps URL" },
    { k: "rating_value", label: "Average rating (e.g. 4.9) — shows star rich snippet in Google" },
    { k: "rating_count", label: "Number of reviews (e.g. 57)" },
    { k: "rating_source", label: "Rating source (Google / Houzz / etc.)" },
  ];

  return (
    <div className="max-w-2xl">
      <h1 className="text-white font-display text-4xl font-bold mb-1">Settings</h1>
      <p className="text-[#6b7683] mb-8">Business contact information displayed across the site.</p>
      <div className="bg-[#141a22] rounded-xl p-8 border border-white/5 space-y-5">
        {fields.map((f) => (
          <div key={f.k}>
            <div className="text-sm text-[#9aa4af] mb-1.5">{f.label}</div>
            <input className={inputCls} value={form[f.k] || ""} onChange={(e) => set(f.k, e.target.value)} />
          </div>
        ))}
        <div className="flex items-center gap-4 pt-2">
          <button onClick={save} className="flex items-center gap-2 px-8 py-3 rounded-lg bg-[#2f9fe6] text-white font-semibold hover:bg-[#1f82c7]"><Save className="w-4 h-4" /> Save</button>
          {saved && <span className="flex items-center gap-2 text-emerald-400 text-sm"><CheckCircle2 className="w-4 h-4" /> Saved</span>}
        </div>
      </div>
    </div>
  );
}
